import { withStyles } from "@material-ui/core";
import { memo } from "react";
const styles = () => ({
  container: {
    padding: 8,
    display: "flex",
    alignItems: "center",
    paddingRight: 100,
    justifyContent: "flex-end",
    "& button:not(:first-child)": {
      marginLeft: 16,
    },
  },
});
const Footer = ({
  children,
  classes,
}) => {
  return (
    <div id="footer" className={classes.container}>
      {children}
    </div>
  );
};

export default memo(withStyles(styles)(Footer));
